/**
 * @param {Element} element - The element to focus to.
 * @param {boolean} forceFocus - Focus on elements that normally aren't focusable.
 */
export var focus = function focus(element, forceFocus) {
  if (!element) return;
  forceFocus && element.setAttribute('tabindex', '-1');
  element.focus();
};
export default focus;